export default __webpack_public_path__ + "static/vk-4ccc40fd2eb085b3776b533d5ba36f35.png";